var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6399 14.32C28.6399 6.41535 22.2246 0 14.32 0C6.41535 0 0 6.41535 0 14.32C0 21.2508 4.92607 27.0218 11.456 28.3535V18.616H8.59198V14.32H11.456V10.74C11.456 7.97622 13.7042 5.72799 16.468 5.72799H20.048V10.024H17.184C16.3964 10.024 15.752 10.6684 15.752 11.456V14.32H20.048V18.616H15.752V28.5683C22.9835 27.8523 28.6399 21.752 28.6399 14.32Z",
    fill: "#F7F2EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.a99c7c3b7577d437fa26660ef29b8650.svg";
export { ForwardRef as ReactComponent };